import emotion from '../../../assets/imgs/emotion/emotion.json';
import {getCompanyInfo, getNewUserInfo} from "../../../assets/request/Chat/PCChatRequest";
import {getProvinceInfo} from '../../../assets/request/Company/CompanyRequest';
import {sendChat} from '../../../assets/request/Socket/ChatSocket';
import {dateFormat} from "../../../assets/mixins/Chat/ChatRoomSet";
import {CHAT_MESSAGE_TYPE} from '../../../components/store/common';

const chatVuex = {
  state: {
    connectionStatePrompt: '',/*websocket 异常提示*/
    emotion,/*表情图片代码*/
    repeatLoginPrompt: '',/*这是错误提示信息*/
    connectionState: false,
    repeatLogin: false,/*是否重复登录*/
    PCChatOpen: false,/*pc chat 是否打开*/
    searchText: '',
    chat: {
      list: {},
      listArray: [],
      selectedInfo: {
        item: '',
        index: '',
        fcName: ''
      },
      selectedOpenOrderInfo: {
        thisCompanyId: '',
        buyerCompanyId: '',
        buyerContactId: '',
        buyerContactName: '',
        buyerContactMobile: '',
      },
      chatDetail: [],
      newAddLength: 0
    },
    unReadSum: 0,/*未读消息总数*/
    search: {
      info: {}
    },
    showRoomFriend: false,
    roomUserArray: [],/*请求过的用户Id可能存在异步，避免多次请求，造成内存溢出*/
    roomUser: {}/*房间列表的后台接口没有返回的用户，一般用于公司变更，造成的用户丢失的情况*/
  },
  mutations: {
    /*更新选中开单给的采购商的信息*/
    updateSelectedOpenOrderInfo(state, {
      thisCompanyId,
      buyerCompanyId,
      buyerContactId,
      buyerContactName,
      buyerContactMobile,
    }) {
      state.chat.selectedOpenOrderInfo = {
        thisCompanyId,
        buyerCompanyId,
        buyerContactId,
        buyerContactName,
        buyerContactMobile
      };
    },
    /*前置聊天列表其中的一个排名*/
    updateChatListArrayItemArray(state, {item}) {
      const listArrayIndex = state.chat.listArray.findIndex(i => i === item);
      state.chat.listArray.splice(listArrayIndex, 1);
      state.chat.listArray.unshift(item);
    },
    /*更改 websocket 异常提示文字*/
    updateConnectionStatePrompt(state, {value}) {
      state.connectionStatePrompt = value;
    },
    /*增加请求过的数组id*/
    addRoomUserArray(state, {id}) {
      let roomUserArray = [...state.roomUserArray];
      roomUserArray.push(id);
      state.roomUserArray = roomUserArray;
    },
    /*增加一个可能未识别的roomUser*/
    addRoomUser(state, {id, dataObject}) {
      let roomUser = {...state.roomUser};
      roomUser[id] = dataObject;
      state.roomUser = roomUser;
    },
    /*更改上滑历史记录条数*/
    updateChatNewAddLength(state, {num}) {
      state.chat.newAddLength = num
    },
    /*更改是饭否为第一次请求历史记录的状态为请求过了已经*/
    updateIfFirst(state, {item}) {
      state.chat.list[item].ifFirst = 1
    },
    /*更改显示房间朋友*/
    updateShowRoomFriend(state) {
      state.showRoomFriend = !state.showRoomFriend
    },
    /*pc初始化，请求聊天记录后变成1*/
    /*重新连接，清空原有的数据*/
    clearChatInfo(state) {
      state.chat.list = {};
      state.chat.listArray = [];
      state.chat.chatDetail = [];
      state.chat.selectedInfo.item = '';
      state.chat.selectedInfo.index = '';
      state.chat.selectedInfo.fcName = '';

    },
    /*清空选中聊天记录*/
    clearChatDetail(state) {
      state.chat.chatDetail = []
    },
    /*更改重复登录的提示信息*/
    updateRepeatLoginPrompt(state, value) {
      state.repeatLoginPrompt = value;
    },
    /*更改搜索的公司信息*/
    updateSearchCompanyInfo(state, value) {
      Object.entries(value).forEach(item => {
        item[1].selected = true;
      })
      state.search.info = value;
    },
    /*接收别人给自己发送过来的信息*/
    receivingChat(state, {value, fid}) {
      console.log(value);
      console.log(state.chat.list);
      console.log(state.chat.list[value.roomId].unReadNum);
      state.chat.list[value.roomId].unReadNum += 1;
      let listArray = state.chat.listArray;
      state.chat.listArray.splice(listArray.findIndex(item => item === value.roomId), 1)
      state.chat.listArray.unshift(value.roomId)
      console.log(state.chat.list[value.roomId].unReadNum);
      state.chat.list[value.roomId].chatDetail.push(value)
      if (state.chat.selectedInfo.item === value.roomId) state.chat.chatDetail = [...state.chat.list[value.roomId].chatDetail];
      if (value.fromUser === fid) state.chat.list[value.roomId].unReadNum = 0;
    },
    /*更改聊天记录*/
    updateChatDetail(state, value) {
      console.log(value);
      state.chat.newAddLength = value.data.length;
      if (state.chat.list[value.item]) {
        state.chat.list[value.item].chatDetail = value.data.concat(state.chat.list[value.item].chatDetail);
        if (state.chat.selectedInfo.item === value.item) {
          state.chat.chatDetail = [...state.chat.list[value.item].chatDetail];
        }
      }
    },
    /*切换聊天对象*/
    toggleChatObject(state, value) {
      state.chat.chatDetail = [...state.chat.list[value].chatDetail];
      state.chat.list[value].unReadNum = 0;
    },
    /*更改pc状态*/
    updatePCChatState(state, value) {
      state.PCChatOpen = value;
    },
    /*更改登录状态*/
    updateRepeatLogin(state, value) {
      state.connectionState = value;
    },
    /*检测登录状态使用,备注发现引用改掉*/
    checkRepeatLogin(state, value) {
      state.repeatLogin = value;
    },
    /*更多的聊天信息加载，不能替换之前的*/
    loadMoreChatListInfo(state, value) {
      Object.assign(state.chat.list, value);
      state.chat.listArray = state.chat.listArray.concat(Object.keys(value));
    },
    /*更改聊天信息数据*/
    chatListInfo(state, value) {
      state.chat.list = value;
      state.chat.listArray = Object.keys(value)
    },
    /*有参数的聊天信息加载*/
    chatListInfoHaveParam(state, value) {
      this.commit('chatListInfo', value.res);
      this.commit('updateSelectedInfo', {
        item: value.roomId,
        index: 0,
        fcName: value.res[value.roomId].friendName
      })
      /*console.log(value);*/
    },
    /*更新聊天信息数据，选中第一个(数据过多使用，多次加载)*/
    loadMoreChatListInfoSelect1st(state, {list, item, index, fcName}) {
      Object.assign(state.chat.list, list);
      state.chat.listArray = state.chat.listArray.concat(Object.keys(list));
      state.chat.selectedInfo.item = (Array.isArray(item)) ? item[0] : item;
      state.chat.selectedInfo.index = index;
      state.chat.selectedInfo.fcName = fcName;
      state.chat.list[item].unReadNum = 0;
    },
    /*更新聊天信息数据，选中第一个*/
    chatListInfoSelect1st(state, {list, listArray, item, index, fcName}) {
      state.chat.list = list;
      state.chat.listArray = listArray;
      state.chat.selectedInfo.item = Array.isArray(item) ? item[0] : item;
      state.chat.selectedInfo.index = index;
      state.chat.selectedInfo.fcName = fcName;
      state.chat.list[item].unReadNum = 0;
    },
    /*搜索输入的信息*/
    enterSearchText(state, value) {
      state.searchText = value
    },
    /*改变选中信息*/
    updateSelectedInfo(state, value) {
      console.log(value);
      state.chat.selectedInfo.item = Array.isArray(value.item) ? value.item[0] : value.item;
      state.chat.selectedInfo.index = value.index;
      state.chat.selectedInfo.fcName = value.fcName;
      String(value.item) ? state.chat.list[value.item].unReadNum = 0 : null;
    },
    /*选中聊天房间 单个*/
    updateSelectedInfoSingle(state, {item = '', index = 0, fcName = ''}) {
      state.chat.selectedInfo.item = item;
      state.chat.selectedInfo.index = index;
      state.chat.selectedInfo.fcName = fcName;
      String(value.item) ? state.chat.list[item].unReadNum = 0 : null;
    },
    /*发送消息*/
    sendChat(state, value) {
      if (value.data.room === state.chat.selectedInfo.item) {
        state.chat.list[state.chat.selectedInfo.item].chatDetail.push(value.data);
        state.chat.chatDetail = [...state.chat.list[state.chat.selectedInfo.item].chatDetail];
        return;
      }
      state.chat.list[value.data.room].chatDetail.push(value.data);
    },
    /*已经进入的房间群发消息，并且以上所以房间未选中时调用*/
    hasEnteredTheRoomSendChatGroupAndDoNotSelect(state, {text = '', item = [], thisUserId = ''}) {
      if (!String(text)) return;
      if (!item.length) return;
      if (!String(thisUserId)) return;
      item.filter(item => Number(state.chat.list[item].ifFirst) === 1).forEach(item => {
        const sendChatJSON = sendChat({
          fromUser: thisUserId,
          room: item,
          msg: text,
          msgType: CHAT_MESSAGE_TYPE.RICH_TEXT,
        }).data;
        sendChatJSON['ctime'] = dateFormat({create: true});
        state.chat.list[item].chatDetail.push(sendChatJSON);
      })

    },
    /**
     * 发送开单
     */
    sendOpenOrder(state, value) {
      state.chat.list[state.chat.selectedInfo.item].chatDetail.push(value.data);
      state.chat.chatDetail = [...state.chat.list[state.chat.selectedInfo.item].chatDetail];
    },
    /*建立部分聊天数组*/
    createChatArrayVuex(state, {list = {}}) {
      if (!Object.keys(list).length) return;
      state.chat.list = {
        ...state.chat.list,
        ...list,
      };
      state.chat.listArray = [...state.chat.listArray, ...Object.keys(list)];
    },
    /*建立聊天 */
    createChat(state, value) {
      console.log(value);
      console.log(Object.keys(value.item)[0]);
      console.log(value.item[Object.keys(value.item)[0]]);
      state.chat.list[Object.keys(value.item)[0]] = value.item[Object.keys(value.item)[0]];
      state.chat.listArray.unshift(value.arr)/*这里传第一个元素*/
    },
    /* 创建单个聊天 */
    createChatSingle(state, {objectInfo = {}, key = ''}) {
      state.chat.list[key] = objectInfo;
      state.chat.listArray.unshift(key);
    },
    /* 修改搜索多选选中 */
    searchSelectMultiple(state, {id = 0}) {
      if (!id) return;
      Object.entries(state.search.info).forEach(item => {
        if (Number(item[1].Id) === Number(id)) item[1].selected = !item[1].selected;
      });
    },
  },
  actions: {
    addRoomUserAsync({commit, getters}, {id, authKey}) {
      console.log('addRoomUserAsync 0---------');
      console.log(this);
      console.log('addRoomUserAsync authKey=' + authKey)
      if (getters.getRoomUserArray.some(item => item === id)) return console.log(getters.getRoomUserArray.some(item => item === id));

      commit('addRoomUserArray', {id});
      let dataObject = {};
      getNewUserInfo(authKey, id).then(res => {
        if (parseInt(res.data.code) === 1) {
          dataObject=res.data.data.user;
          return getProvinceInfo({token:authKey,code:res.data.data.user.cityCode})
        }
        return Promise.reject(res);

      }).catch(res => {
        return Promise.reject(res);
        // alert(`发生严重错误，请截全屏给开发者==================${JSON.stringify(res)}`)
      }).then(value => {
        if(value.status!==200) return;
        dataObject['districtInfo'] = value.dataItem;
        commit('addRoomUser', {
          id,
          dataObject
        });
      }).catch(reason=>{
        console.log(reason);
      });;


    },
    /*异步更新聊天记录*/
    chatListInfo(context, param) {
      setTimeout(() => {
        context.commit('chatListInfo', param)
      }, 0)
    },
    /*接受别人给自己发来的消息。处理没有建立聊天的连接*/
    receivingChatAsync({commit, getters}, {param, authKey, fid}) {
      new Promise(resolve => {
        console.log(getters.getChatList.arr);
        console.log(param)
        let existsRoom = getters.getChatList.arr.find(item => {
          console.group('getters.getChatList.arr.find-----------')
          console.log(item);
          console.log(param.roomId);
          console.groupEnd();
          return item === param.roomId
        });
        console.log(existsRoom);
        if (!existsRoom) {
          console.log('existsRoom-----------------------------' + existsRoom);
          getCompanyInfo(authKey, JSON.stringify({[param.roomId]: {unReadNum: 0}})).then(res => {
            let resData = res.data.data;
            console.log(resData);
            commit('createChat', {
              item: resData,
              arr: Object.keys(resData)[0]
            })
            resolve(resData)
          })
        } else {
          resolve(existsRoom)
        }

      })
        .then(res => {
          console.log(param);
          console.log(res);
          commit('receivingChat', {value: param, fid})
        })
    },
    /*异步更改搜索内容*/
    updateSearchCompanyInfoAsync({commit}, param) {
      commit('updateSearchCompanyInfo', param)
    },
    updateSelectedInfoAsync({commit}, param) {
      console.log(param)
      commit('updateSelectedInfo', param);
    }
  },
  getters: {
    /*获取选择开单的公司及成员信息*/
    getSelectedOpenOrderInfo: state => state.chat.selectedOpenOrderInfo,
    /*获取异常提示文字*/
    getConnectionStatePrompt: state => state.connectionStatePrompt,
    /*获取未找到的信息的数组*/
    getRoomUserArray: state => state.roomUserArray,
    /*获取未找到的用户的信息*/
    getRoomUser: state => {
      return {
        ...state.roomUser
      }
    },
    /*获取表情图片代码*/
    getEmotion: state => state.emotion.map(item => {
      return {
        url: `/union/static/image/emotion/${item.name}.png`,
        name: item.name,
        text: item.text
      };
    }),
    /*获取定义的显示房间*/
    getShowRoomFriend: state => state.showRoomFriend,
    /*获取重复登录的提示信息*/
    getRepeatLoginPrompt: state => state.repeatLoginPrompt,
    /*获取搜索的公司信息*/
    getSearchCompanyInfo: state => state.search.info,
    /*获取搜索的内容*/
    getSearchText: state => state.searchText,
    /*获取聊天信息*/
    getChatList(state) {
      return {
        list: state.chat.list,
        arr: state.chat.listArray,
        length: state.chat.listArray.length,
        item: state.chat.selectedInfo.item,
        index: state.chat.selectedInfo.index,
        fcName: state.chat.selectedInfo.fcName,
        chat: state.chat.chatDetail
      }
    },
    /*获取聊天记录*/
    getChatDetail: (state, getters) => {
      return state.chat.chatDetail.map(item => {
        const returnObject = {
          ...item,
        };
        if (getters.getChatList.list[getters.getChatList.item].memberDetailArr[item.fromUser]) {
          returnObject.name = getters.getChatList.list[getters.getChatList.item].memberDetailArr[item.fromUser].name;
          returnObject.cname = getters.getChatList.list[getters.getChatList.item].memberDetailArr[item.fromUser].cname;
          returnObject.mobile = getters.getChatList.list[getters.getChatList.item].memberDetailArr[item.fromUser].mobile;
          returnObject.headImg = getters.getChatList.list[getters.getChatList.item].memberDetailArr[item.fromUser].headImg;

          returnObject.province = getters.getChatList.list[getters.getChatList.item].memberDetailArr[item.fromUser].address.province;
          returnObject.city = getters.getChatList.list[getters.getChatList.item].memberDetailArr[item.fromUser].address.city;
          returnObject.county = getters.getChatList.list[getters.getChatList.item].memberDetailArr[item.fromUser].address.county;
          returnObject.address = getters.getChatList.list[getters.getChatList.item].memberDetailArr[item.fromUser].address.address;
        }
        return returnObject;
      });

      /*let chat = state.chat.chatDetail;
      chat.forEach(item => {
        if (getters.getChatList.list[getters.getChatList.item].memberDetailArr[item.fromUser]) {
          item.name = getters.getChatList.list[getters.getChatList.item].memberDetailArr[item.fromUser].name;
          item.cname = getters.getChatList.list[getters.getChatList.item].memberDetailArr[item.fromUser].cname;
          item.mobile = getters.getChatList.list[getters.getChatList.item].memberDetailArr[item.fromUser].mobile;
          item.headImg = getters.getChatList.list[getters.getChatList.item].memberDetailArr[item.fromUser].headImg;
          item.province = getters.getChatList.list[getters.getChatList.item].memberDetailArr[item.fromUser].address.province;
          item.city = getters.getChatList.list[getters.getChatList.item].memberDetailArr[item.fromUser].address.city;
          item.county = getters.getChatList.list[getters.getChatList.item].memberDetailArr[item.fromUser].address.area;
          item.address = getters.getChatList.list[getters.getChatList.item].memberDetailArr[item.fromUser].address.address;
        }
      })
      return chat;*/

    },
    /*获取PC各种状态*/
    getPCChatState(state) {
      return {openState: state.PCChatOpen, isRepeatLogin: state.repeatLogin}
    },
    /*获取所有的未读消息条数*/
    getAllUnReadNum: state => Object.keys(state.chat.list).map(item => state.chat.list[item].unReadNum).reduce((total, currentValue) => total + currentValue, 0),
    /*获取历史记录时候返回的条数*/
    getNewAddLength: state => state.chat.newAddLength,
    /*获取聊天连接状态是否重复或者断开*/
    getConnectionIsRepeat: state => state.connectionState
  }
}
export default chatVuex;
